import "core-js/modules/es.array.map.js";
import React, { useEffect, useCallback } from 'react';
import Carousel from 'react-material-ui-carousel';
import { Backdrop, IconButton } from '@material-ui/core';
import { CloseOutlineIcon } from '@applyboard/ui-icons';
import { WHITE, GRAY } from "../../constants/colors/hex";
import { ImageWithFallback } from "../ImageWithFallback";
var SlideShowItem = function SlideShowItem(_ref) {
  var item = _ref.item;
  return item.type === 'video' ? /*#__PURE__*/React.createElement("iframe", {
    width: "1024",
    height: "768",
    src: item.video,
    title: "YouTube video player",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    style: {
      backgroundColor: WHITE,
      backgroundImage: "url(\"".concat(item.original, "\")"),
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }
  }) : /*#__PURE__*/React.createElement(ImageWithFallback, {
    src: item.optimized,
    srcFallback: item.original,
    alt: item.photoFileName,
    loading: "lazy"
  });
};
export var Slideshow = function Slideshow(_ref2) {
  var items = _ref2.items,
    openIndex = _ref2.openIndex,
    onChange = _ref2.onChange,
    classNames = _ref2.classNames;
  var numberOfPhotos = items.length;
  var onExit = useCallback(function () {
    return onChange(null);
  }, [onChange]);
  var onIncrement = useCallback(function () {
    return onChange(function (currentIndex) {
      return currentIndex === numberOfPhotos - 1 ? 0 : currentIndex + 1;
    });
  }, [onChange, numberOfPhotos]);
  var onDecrement = useCallback(function () {
    return onChange(function (currentIndex) {
      return currentIndex === 0 ? numberOfPhotos - 1 : currentIndex - 1;
    });
  }, [onChange, numberOfPhotos]);
  var handleOnKeyDown = useCallback(function (event) {
    if (openIndex === null) {
      return;
    }
    switch (event.key) {
      case 'ArrowRight':
        onIncrement();
        break;
      case 'ArrowLeft':
        onDecrement();
        break;
      case 'Escape':
        onExit();
        break;
    }
  }, [openIndex, numberOfPhotos, onIncrement, onDecrement, onExit]);
  useEffect(function () {
    document.addEventListener('keydown', handleOnKeyDown);
    return function () {
      return document.removeEventListener('keydown', handleOnKeyDown);
    };
  }, [handleOnKeyDown]);
  return /*#__PURE__*/React.createElement(Backdrop, {
    open: openIndex !== null,
    className: classNames.backdropStyle,
    "aria-hidden": openIndex === null
  }, openIndex !== null && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Carousel, {
    index: openIndex || 0,
    animation: "slide",
    navButtonsAlwaysVisible: true,
    autoPlay: false,
    className: classNames.carouselStyle,
    fullHeightHover: false,
    navButtonsProps: {
      style: {
        backgroundColor: GRAY[5]
      }
    },
    strictIndexing: true,
    next: onIncrement,
    prev: onDecrement
  }, items === null || items === void 0 ? void 0 : items.map(function (item) {
    return /*#__PURE__*/React.createElement(SlideShowItem, {
      item: item,
      key: item.id
    });
  })), /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "close slideshow",
    style: {
      position: 'absolute',
      top: '16px',
      right: '16px',
      backgroundColor: GRAY[5],
      color: WHITE
    },
    onClick: onExit
  }, /*#__PURE__*/React.createElement(CloseOutlineIcon, {
    color: "white"
  }))));
};